import { CONFETTI_AUTO_RUN, CONFETTI_COLOURS } from 'loyalty/constants/loyaltyConfetti'
import type { ComponentProps } from 'react'
import { useCallback } from 'react'
import RealisticConfetti from 'react-canvas-confetti/dist/presets/realistic'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

interface Props {
  tier: App.LoyaltyTier
}

const ConfettiLayer = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: ${zIndex.notification};
`

function LoyaltyActionRewardCelebrationConfetti({ tier }: Props) {
  const confettiColours = CONFETTI_COLOURS[tier]
  const confettiDecoration = useCallback<NonNullable<ComponentProps<typeof RealisticConfetti>['decorateOptions']>>((options) => ({
    ...options,
    colors: confettiColours,
    origin: { y: 0.45, x: 0.5 },
    zIndex: zIndex.notification,
  }), [confettiColours])

  return (
    <ConfettiLayer>
      <RealisticConfetti autorun={CONFETTI_AUTO_RUN} decorateOptions={confettiDecoration} />
    </ConfettiLayer>
  )
}

export default LoyaltyActionRewardCelebrationConfetti
